import { Card } from "antd";
import message from "../../assets/icons/purpleMessageIcon.svg";
import Face from "../../assets/icons/Face.png";
import ordersIcon from "../../assets/icons/OrangeOrderIcon.svg";
import profileImage from "../../assets/icons/Avatar.png";
const HomeMessageCard = ({ order, data }) => {
  return (
    <Card className="h-18 shadow-md">
      {order ? (
        <div className="m-2 mt-1 flex flex-col px-2">
          <div className="flex">
            <img className="mr-1" src={ordersIcon} alt="Background" />
            <p className="text-base font-mediuml text-primaryOrange">
              Order History
            </p>
          </div>
          {data ? (
            <div className="space-y-1">
              {data?.slice(0, 2)?.map((item, i) => (
                <div className="flex items-center shadow-sm w-20" key={i}>
                  <img
                    className="mr-1 h-3 w-3 rounded-full"
                    src={item?.userId?.profileImage ?? profileImage}
                    alt="Background"
                  />
                  <div className="">
                    <p className="my-0">{`${item?.userId?.firstName} ${item?.userId?.lastName}`}</p>
                    <p className="text-primaryOrange my-0 text-sm">
                      ORDER # {item?._id.slice(-6)}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-lg flex justify-center items-center opacity-60 mt-2">
              No Orders...
            </p>
          )}
        </div>
      ) : (
        <div className="m-2 mt-1 flex flex-col px-2">
          <div className="flex ">
            <img className="mr-1" src={message} alt="Background" />
            <p className="text-base font-medium text-primaryPurple">
              Latest Messages
            </p>
          </div>
          {data ? (
            <div>
              <div className="flex items-center shadow-sm w-20">
                <img className="mr-1" src={Face} alt="Background" />
                <p>Ok, I will be there.</p>
              </div>
              <div className="flex items-center w-20">
                <img className="mr-1" src={Face} alt="Background" />
                <p className="line-clamp-1">I had an Appointment with you.</p>
              </div>
            </div>
          ) : (
            <p className="text-lg flex justify-center font-medium	 items-center opacity-60 mt-2">
              No Messages...
            </p>
          )}
        </div>
      )}
    </Card>
  );
};
export default HomeMessageCard;
